__turbopack_context__.v({
  "body": "SearchOverlay-module__166Y7a__body",
  "overlay": "SearchOverlay-module__166Y7a__overlay",
  "srOnly": "SearchOverlay-module__166Y7a__srOnly",
});
